import { QUESTION_CONVERSATIONAL } from '../../../../constants';

export default function isValid(question) {
  if (question.style !== QUESTION_CONVERSATIONAL) {
    return true;
  }

  return true;
}
